export class ApplicationSettings {
    version: string;

    // obsolute properties
    tenantId: string = 'acibadem';
}